import React, { useState } from 'react'
import {
  // Avatar,
  Box,
  // Button,
  Card,
  // CardActions,
  CardContent,
  CardMedia,
  Grid,
  H3,
  IconButton,
  makeStyles,
  PageTitle,
  Tooltip,
} from '@perk-ui/core'
// import clsx from 'clsx'
import { ArrowLeft, HelpCircle } from 'react-feather'

import DataPair from '../../components/DataPair'
import TableauView from '../../components/TableauView'
import { availableNavigationOptions } from '../../config/constants'
import queryClient from '../../config/react-query'
import { useUser } from '../../features/auth/AuthContext'
import QueryKeys from '../../features/query-hooks/QueryKeys'

interface MyAccessProps {}

const useStyles = makeStyles((theme) => ({
  navigationOptionButton: {
    '&:hover': {
      opacity: 0.8,
      color: theme.palette.primary.dark,
    },
  },
  active: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
    '&:hover': {
      backgroundColor: theme.palette.primary.dark,
      color: theme.palette.common.white,
    },
  },
  navigationOptionCard: {
    display: 'flex',
    padding: theme.spacing(2),
    cursor: 'pointer',
    border: 'solid 1px transparent',
    height: '100%',
    '&:hover': {
      opacity: '0.8',
      border: 'solid 1px #b3b3b3',
    },
  },
  navigationOptionCardMedia: {
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    borderRadius: '12px',
    padding: theme.spacing(0, 2),
    // marginBottom: 'auto',
    objectFit: 'contain',
    objectPosition: 'top',
    width: '30%',
    height: '150px',
    display: 'flex',
    justifyContent: 'center',
  },
  // adverseEventReportBg: {
  //   backgroundImage:
  //     'url(' + process.env.PUBLIC_URL + '/assets/card-gradient.jpg)',
  // },
  // complianceReportBg: {
  //   backgroundImage:
  //     'url(' + process.env.PUBLIC_URL + '/assets/card-gradient.jpg)',
  // },
  // explorersBg: {
  //   backgroundImage:
  //     'url(' + process.env.PUBLIC_URL + '/assets/card-gradient.jpg)',
  // },
  // satisfactionReportBg: {
  //   backgroundImage:
  //     'url(' + process.env.PUBLIC_URL + '/assets/card-gradient.jpg)',
  // },
  // scorecardsBg: {
  //   backgroundImage:
  //     'url(' + process.env.PUBLIC_URL + '/assets/card-gradient.jpg)',
  // },
  // summaryBg: {
  //   backgroundImage:
  //     'url(' + process.env.PUBLIC_URL + '/assets/card-gradient.jpg)',
  // },
  navigationOptionCardContent: {
    width: '70%',
    padding: theme.spacing(0, 3),
    '& h3': {
      marginBottom: theme.spacing(1),
      fontSize: '26px',
      fontWeight: 700,
      lineHeight: '28px',
      fontStyle: 'normal',
    },
    '& span': {
      fontWeight: 700,
    },
  },
  navigationOptionMediaAvatar: {
    backgroundColor: '#FFFFFF70',
    margin: 'auto',
    color: '#FF794D',
    height: '80px',
    width: '80px',
  },
  navigationIcon: {
    width: '90px',
    height: '90px',
    margin: 'auto',
  },
  navigationOptionCardActions: {
    padding: 0,
    '& button': {
      padding: theme.spacing(1, 2),
      borderRadius: '16px',
    },
  },
  dataPairDesc: {
    margin: 0,
    display: 'inline',
    '& svg': {
      verticalAlign: 'middle',
      marginLeft: theme.spacing(1),
      marginBottom: theme.spacing(0.3),
      color: theme.palette.primary.main,
    },
  },
  navigationDataPair: {
    fontWeight: 400,
    // display: 'inline-flex',
  },
  navigationTooltip: {
    fontSize: '16px',
    fontWeight: 400,
  },
}))

const MyAccess: React.FC<MyAccessProps> = () => {
  const classes = useStyles()
  const [activeNavigation, setActiveNavigation] = useState('')
  const currentUser = useUser()
  const accessUserTableauSubscription =
    currentUser?.accessUser?.sponsor?.subscriptionPlan || ''
  queryClient.invalidateQueries(
    QueryKeys.tableauToken(
      'access',
      'views/Sponsor_ACCESSPremium/StandardExplorer',
    ),
  )
  const toRemove = (): string[] => {
    switch (accessUserTableauSubscription) {
      case 'basic':
        return [
          'Enrollment Trends',
          'Outcome Explorers',
          'Patient Satisfaction',
          'Adverse Events',
          'Scorecards',
        ]
      case 'standard':
        return ['Patient Satisfaction', 'Adverse Events', 'Scorecards']
      case 'premium':
        return []
      default:
        return [
          'Summary Reports',
          'Enrollment Trends',
          'Outcome Explorers',
          'Patient Satisfaction',
          'Adverse Events',
          'Scorecards',
        ]
    }
  }
  const filteredAvailableNavigationOptions = availableNavigationOptions.filter(
    (option) => {
      return !toRemove().includes(option)
    },
  )
  // Need conditionals for the workbookUrl based on the subscription
  const getWorkbookUrl = () => {
    switch (accessUserTableauSubscription) {
      case 'basic':
        switch (activeNavigation) {
          case 'Summary Reports':
            return 'views/summary_basic/StarterSummaryHome'
          case 'Enrollment Trends':
          case 'Outcome Explorers':
          case 'Patient Satisfaction':
          case 'Adverse Events':
          case 'Scorecards':
          default:
            return ''
        }
      case 'standard':
        switch (activeNavigation) {
          case 'Summary Reports':
            return 'views/summary_standard/StandardSummaryHome'
          case 'Enrollment Trends':
            return 'views/enrollment_compliance/EnrollmentTrendsHome'
          case 'Outcome Explorers':
            return 'views/explorer_standard/StandardExplorerHome'
          case 'Patient Satisfaction':
          case 'Adverse Events':
          case 'Scorecards':
          default:
            return ''
        }
      case 'premium':
        switch (activeNavigation) {
          case 'Summary Reports':
            return 'views/summary_premium/PremiumSummaryHome'
          case 'Enrollment Trends':
            return 'views/enrollment_compliance/EnrollmentTrendsHome'
          case 'Outcome Explorers':
            return 'views/explorer_premium/StandardExplorerHome'
          case 'Patient Satisfaction':
            return 'views/satisfaction/PatientSatisfactionHome'
          case 'Adverse Events':
            return 'views/adverse_events/AdverseEventsHome'
          case 'Scorecards':
            return 'views/scorecards/ScorecardsHome'
          default:
            return ''
        }
      default:
        return ''
    }
  }

  const getNavigationOptionDescription = (option: string) => {
    switch (option) {
      case 'Summary Reports':
        return (
          <p className={classes.dataPairDesc}>
            Access curated summaries and registry-wide trends in enrollment,
            outcomes, and performance, with global or clinic-level filtering
            based on your subscription.
          </p>
        )
      case 'Enrollment Trends':
        return (
          <p className={classes.dataPairDesc}>
            Visualize case enrollment and survey compliance across time period,
            providers, and treatment types to monitor data collection
            performance.
          </p>
        )
      case 'Outcome Explorers':
        return (
          <p className={classes.dataPairDesc}>
            Explore detailed outcome trends across different patient cohorts
            using interactive dashboards with filters for demographics,
            conditions, treatments, and outcome measures like pain, function,
            and mental health.
          </p>
        )
      case 'Patient Satisfaction':
        return (
          <p className={classes.dataPairDesc}>
            Analyze patient-reported satisfaction by treatment, provider, and
            profile, and generate ready-to-use patient testimonial slides for
            marketing or quality initiatives.
          </p>
        )
      case 'Adverse Events':
        return (
          <p className={classes.dataPairDesc}>
            View patient-reported adverse symptoms and reactions, including
            event type, severity, relatedness, and actions taken, with both
            visuals and raw data access.
          </p>
        )
      case 'Scorecards':
        return (
          <p className={classes.dataPairDesc}>
            Quickly review top-line performance summaries for specific
            treatments, conditions, or providers, making it easy to benchmark
            and compare outcomes.
          </p>
        )
      default:
        return ''
    }
  }
  const getNavigationOptionTitle = (option: string) => {
    switch (option) {
      case 'Summary Reports':
        return (
          <span className={classes.dataPairDesc}>
            {option}
            <Tooltip
              arrow
              title={
                <div className={classes.navigationTooltip}>
                  {
                    "Use this section to understand: How do our trends compare to the national registry? What's our registry-wide performance by treatment type or condition?"
                  }
                </div>
              }
            >
              <HelpCircle size={20} />
            </Tooltip>
          </span>
        )
      case 'Enrollment Trends':
        return (
          <span className={classes.dataPairDesc}>
            {option}
            <Tooltip
              arrow
              title={
                <span className={classes.navigationTooltip}>
                  {
                    "Use this section to find: What is our clinic's 6-month survey compliance rate? How many open surveys remain? Which provider has the best compliance at baseline?"
                  }
                </span>
              }
            >
              <HelpCircle size={20} />
            </Tooltip>
          </span>
        )
      case 'Outcome Explorers':
        return (
          <span className={classes.dataPairDesc}>
            {option}
            <Tooltip
              arrow
              title={
                <span className={classes.navigationTooltip}>
                  {
                    'Use this section to answer: Which treatments lead to the best outcomes for specific patient groups? How many PRP cases has our practice performed? What’s the average number of sessions per patient?'
                  }
                </span>
              }
            >
              <HelpCircle size={20} />
            </Tooltip>
          </span>
        )
      case 'Patient Satisfaction':
        return (
          <span className={classes.dataPairDesc}>
            {option}
            <Tooltip
              arrow
              title={
                <span className={classes.navigationTooltip}>
                  {
                    'Use this section to explore: What is our 6-month satisfaction rate? Which patient types report the highest satisfaction? How do satisfaction levels vary by treatment or provider?'
                  }
                </span>
              }
            >
              <HelpCircle size={20} />
            </Tooltip>
          </span>
        )
      case 'Adverse Events':
        return (
          <span className={classes.dataPairDesc}>
            {option}
            <Tooltip
              arrow
              title={
                <span className={classes.navigationTooltip}>
                  {
                    'Use this section to investigate: What is our severe adverse event rate? How often do infections occur? What symptoms are most commonly reported, and what do patients do in response?'
                  }
                </span>
              }
            >
              <HelpCircle size={20} />
            </Tooltip>
          </span>
        )
      case 'Scorecards':
        return (
          <span className={classes.dataPairDesc}>
            {option}
            <Tooltip
              arrow
              title={
                <span className={classes.navigationTooltip}>
                  {
                    'Use this section to discover: Which treatments work best for patients with moderate knee OA? How do outcomes vary between providers for a given condition or intervention?'
                  }
                </span>
              }
            >
              <HelpCircle size={20} />
            </Tooltip>
          </span>
        )
      default:
        return ''
    }
  }
  const getNavigationOptionImageUrl = (option: string) => {
    switch (option) {
      case 'Summary Reports':
        return 'Summary_Reports.png'
      case 'Enrollment Trends':
        return 'Enrollment_Trends.png'
      case 'Outcome Explorers':
        return 'Outcome_Explorers.png'
      case 'Patient Satisfaction':
        return 'Patient_Satisfaction.png'
      case 'Adverse Events':
        return 'Adverse_Events.png'
      case 'Scorecards':
        return 'Scorecards.png'
      default:
        return 'default-dbio.png'
    }
  }

  const myAccessTableauParameters = [
    {
      key: 'parameter_select_subscription_type',
      value: 'ACCESS',
    },
    // {
    //   key: 'parameter_select_sponsor_id',
    //   value: currentUser?.accessUser?.sponsorId,
    // },
    // {
    //   key: 'parameter_select_sponsored_user_id',
    //   value: currentUser?.accessUser?.id,
    // },
  ]
  return (
    <Box>
      <PageTitle title="My Access" />
      {activeNavigation === '' && (
        <Grid container spacing={2} p={2}>
          {filteredAvailableNavigationOptions.map((option) => {
            return (
              <Grid item xs={12} sm={6} key={option}>
                <Card
                  key={option}
                  className={classes.navigationOptionCard}
                  onClick={() => setActiveNavigation(option)}
                >
                  {/* <Box display="flex" flexDirection="column" justifyContent="space-between">
                    <Box> */}
                  <CardMedia
                    component="img"
                    className={classes.navigationOptionCardMedia}
                    sx={{ width: 151 }}
                    image={
                      process.env.PUBLIC_URL +
                      '/assets/' +
                      getNavigationOptionImageUrl(option)
                    }
                    alt={option}
                  />
                  <CardContent className={classes.navigationOptionCardContent}>
                    <H3>{getNavigationOptionTitle(option)}</H3>
                    <DataPair
                      customClass={classes.navigationDataPair}
                      label="Description"
                      value={getNavigationOptionDescription(option)}
                    />
                  </CardContent>
                  {/* </Box>
                    <Box>
                      <CardActions className={classes.navigationOptionCardActions}>
                        <Button
                          endIcon={<ArrowRight />}
                          fullWidth
                          size="small"
                          onClick={() => setActiveNavigation(option)}
                        >
                          View
                        </Button>
                      </CardActions>
                    </Box>
                  </Box> */}
                </Card>
              </Grid>
            )
          })}
        </Grid>
      )}

      {activeNavigation !== '' && (
        <Box height={'100%'}>
          <Box display="flex" alignItems={'center'} p={2}>
            <IconButton onClick={() => setActiveNavigation('')}>
              <ArrowLeft />
            </IconButton>
            <H3>{activeNavigation}</H3>
          </Box>
          {getWorkbookUrl() !== '' && (
            <TableauView
              src={getWorkbookUrl()}
              toolbar="top"
              hideTabs={false}
              parameters={myAccessTableauParameters}
              section="my-access"
            />
          )}
        </Box>
      )}
    </Box>
  )
}

export default MyAccess
